/**
 * Platform-wide email sender constants. Shared so the frontend preview, the
 * workloads resolver, and the Temporal worker resolver never drift.
 */
export const EMAIL_REPLY_TO_ADDRESS = 'info@complyance.com';

export const DEFAULT_EMAIL_FROM_LOCAL_PART = 'info';

/** Max length of the From local part (RFC 5321 local-part limit). */
export const EMAIL_FROM_LOCAL_PART_MAX_LENGTH = 64;

/**
 * Allowed From local part: lowercase RFC 5321 dot-atom, must start and end with
 * an alphanumeric.
 */
const EMAIL_FROM_LOCAL_PART_PATTERN = /^[a-z0-9](?:[a-z0-9._+-]{0,62}[a-z0-9])?$/;

export const isValidFromLocalPart = (value: string): boolean =>
  EMAIL_FROM_LOCAL_PART_PATTERN.test(value.trim().toLowerCase());

/**
 * Resolve the stored From local part: the platform default for an empty value,
 * `null` when a value is present but invalid, otherwise the normalized value.
 */
export const normalizeFromLocalPart = (input: string | null | undefined): string | null => {
  if (input == null || input.trim() === '') {
    return DEFAULT_EMAIL_FROM_LOCAL_PART;
  }
  const normalized = input.trim().toLowerCase();
  return isValidFromLocalPart(normalized) ? normalized : null;
};

export const formatPlatformSender = (address: string) => `Complyance <${address}>`;

export const PLATFORM_DEFAULT_SENDER = formatPlatformSender(EMAIL_REPLY_TO_ADDRESS);
